module.exports = __webpack_public_path__ + "static/img/03-3.6987c92d.png";